// Full-width ambient background video section (black & white, autoplay, muted, loop)
export const AmbientVideo = ({ src, label, height = "h-[70vh] md:h-[86vh]", testid = "ambient-video" }) => (
  <section className={`relative w-full overflow-hidden bg-black ${height}`} data-testid={testid}>
    <video
      src={src}
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      aria-hidden="true"
      className="h-full w-full object-cover"
      style={{ filter: "grayscale(1) contrast(1.05)" }}
    />
    {label && (
      <div className="pointer-events-none absolute inset-x-0 bottom-0 edge pb-10">
        <span className="text-[0.7rem] font-semibold uppercase tracking-[0.24em] text-white/80">
          {label}
        </span>
      </div>
    )}
  </section>
);
